<template>
  <div>
    <field-dialog
      :bus="bus"
      @cancel="dialogCancelled"
      @submit="dialogSubmitted"
    />
    <div class="box__header">
      <span class="box__header--text">
        Pola formularza
      </span>
    </div>
    <div class="wrapper">
      <div class="fields">
        <ul class="fields__list">
          <p class="fields__list--empty" v-show="fields.length === 0">
            Wybierz pole po prawej stronie.
          </p>
          <li
            class="field"
            v-for="(field, i) in fields"
            :key="i"
            :class="{
              'field--error': errors[i] && Object.keys(errors[i]).length > 0
            }"
            @click="editField(field, errors[i])"
          >
            <div class="buttons">
              <el-button
                @click.stop="changeOrder(fields, i, 1)"
                v-if="i !== fields.length - 1"
                size="small"
                title="Przesuń w dół"
              >
                <i class="fa fa-arrow-down"></i>
              </el-button>
              <el-button
                @click.stop="changeOrder(fields, i, -1)"
                :style="{ opacity: i !== 0 ? 1 : 0 }"
                size="small"
                title="Przesuń do góry"
              >
                <i class="fa fa-arrow-up"></i>
              </el-button>
              <el-button
                @click.stop="removeField(field, i)"
                type="danger"
                size="small"
              >
                <i class="fa fa-remove"></i>
              </el-button>
            </div>
            <span
              class="html-preview"
              v-if="
                field.resourcetype === 'TextField' ||
                  field.resourcetype === 'CheckboxField'
              "
              v-html="field.text_pl || field.label_pl"
            />
            <strong v-else>{{
              field.text_pl || field.label_pl || 'Pusta nazwa'
            }}</strong
            ><br />
            <small>{{ getLabel(field.resourcetype) }}</small>
          </li>
        </ul>
      </div>
      <div class="types">
        <ul class="types__list">
          <li
            class="type"
            v-for="(type, key) in $store.state.fieldTypes"
            :key="key"
            @click="addField(key)"
          >
            <i class="fa fa-plus-circle"></i> {{ type.label }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import FieldDialog from '@/views/CustomForms/fields/FieldDialog'
import Vue from 'vue'

export default {
  props: ['fields', 'errors'],
  data() {
    return {
      bus: new Vue(),
      selectedField: {}
    }
  },
  beforeMount() {
    this.fetchData()
  },
  components: {
    FieldDialog
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchFieldTypes')
    },
    editField(field, errors = []) {
      this.bus.$emit('openFieldDialog', field, errors)
    },
    addField(type) {
      const field = { resourcetype: type }
      this.fields.push(field)
      this.editField(field)
    },
    getLabel(resourcetype) {
      const field = this.$store.state.fieldTypes[resourcetype]
      const label = field && field.label
      return label || resourcetype
    },
    dialogCancelled() {
      // cancel
    },
    dialogSubmitted() {
      this.$forceUpdate()
    },
    removeField(field, i) {
      this.removeItemFromFormset(this.fields, field)
      this.removeItemFromFormset(this.errors, this.errors[i])
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
}

.fields {
  width: 72%;

  &__list {
    padding: 0;
    list-style-type: none;

    &--empty {
      font-size: 24px;
      font-weight: 300;
    }
  }
}

.field {
  width: 100%;
  padding: 15px 180px 15px 10px;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  cursor: pointer;
  position: relative;

  &:hover {
    background: #f3f3f3;
  }

  &--error {
    border-left: 3px solid red;
    color: red;
  }
}

.types {
  background: #f8f8f8;
  width: 28%;
  padding: 0 20px;

  &__list {
    padding: 0;
    list-style-type: none;
    text-align: right;
  }
}

.type {
  cursor: pointer;
  padding: 6px 10px;
  border-bottom: 1px solid #e2e2e2;
  transition: all 0.5s;

  & i {
    float: left;
    margin-top: 3px;
  }

  &:hover {
    background: #e2e2e2;
  }
}

.buttons {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
